import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

interface PSNTitleAutocompleteProps {
    jobTitles: string[];
    selectedTitle: string;
    onChange: (title: string) => void;
    placeholder?: string;
}

function PSNTitleAutocomplete({ 
    jobTitles, 
    selectedTitle, 
    onChange, 
    placeholder = "Search PSN job titles..." 
}: PSNTitleAutocompleteProps) {
    const handleChange = (_event: React.SyntheticEvent, value: string | null) => {
        onChange(value || '');
    };

    return (
        <Autocomplete
            value={selectedTitle || null}
            onChange={handleChange}
            options={jobTitles || []}
            renderInput={(params) => (
                <TextField 
                    {...params} 
                    variant="outlined" 
                    placeholder={placeholder}
                    size="small"
                />
            )}
            fullWidth
            size="small"
            autoHighlight
            autoComplete
            filterOptions={(options, state) => {
                const filtered = options.filter(option => 
                    option.toLowerCase().includes(state.inputValue.toLowerCase())
                );
                return filtered;
            }}
            disableListWrap
        />
    );
}

export { PSNTitleAutocomplete };
